module.exports = __webpack_public_path__ + "static/media/chengwei2.105e7ed9.png";